import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const STRIPE_PRICE_ID = 'price_1Ty4zYHXfnCCwXgIlQgAQ7us'; // 👈 Hardcoded price ID

export default function PodcastPaywall() {
  const [searchParams] = useSearchParams();
  const roomId = searchParams.get("roomId") || "s8roqh";
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubscribe = async () => {
    setLoading(true);
    setErrorMsg('');
    try {
      const res = await fetch('/api/stripe/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.pb?.authStore?.token}`
        },
        body: JSON.stringify({
          roomId,
          priceId: STRIPE_PRICE_ID // 👈 Send the hardcoded price ID to your server route
        })
      });

      // 1. Check if the server actually returned a success code
      if (!res.ok) {
        // console.error('Server responded with an error:', res.status, res.statusText);
        // const errorData = await res.json();
        // throw new Error(errorData.error || 'Failed to initialize checkout');
        console.error('Server responded with an error:', res.status, res.statusText);
        let errorMessage = `Server Error: ${res.status}`;

        // 👇 THE CHANGE: Only try to parse JSON if the header says it is JSON
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await res.json();
          errorMessage = errorData.error || errorMessage;
        }
        console.error(errorMessage);
        // throw new Error(errorMessage);
        setErrorMsg(errorMessage);
        return; // Exit early since we have an error
      }

      const data = await res.json();

      if (data.url) {
        window.location.href = data.url; // Redirects to Stripe hosted checkout page
      } else {
        console.error('No checkout URL returned from server.');
        setErrorMsg('No checkout URL returned from server.');
      }
    } catch (err) {
      console.error("Payment initiation failed:", err);
      setErrorMsg(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#121212', color: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif', padding: '20px' }}>
      <div style={{ maxWidth: '420px', width: '100%', background: '#1e1e1e', border: '1px solid #2a2a2a', borderRadius: '12px', padding: '30px', textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.5)' }}>

        <h2 style={{ margin: '0 0 10px 0', fontSize: '1.5rem', color: '#fff' }}>Unlock Room Access</h2>
        <p style={{ color: '#a3a3a3', fontSize: '0.95rem', marginBottom: '25px', lineHeight: '1.5' }}>
          Subscribe for $6/mo to join session <span style={{ color: '#c084fc', fontWeight: '600' }}>{roomId}</span> and chat with AI Agent Atlas.
        </p>

        {errorMsg && (
          <div style={{ background: '#451a03', border: '1px solid #78350f', color: '#fde68a', padding: '10px', borderRadius: '6px', fontSize: '0.85rem', marginBottom: '20px' }}>
            {errorMsg}
          </div>
        )}

        <button
          onClick={handleSubscribe}
          disabled={loading}
          style={{ width: '100%', padding: '12px', background: '#9333ea', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '1rem', marginBottom: '15px', transition: 'background 0.2s' }}
        >
          {loading ? 'Preparing Checkout...' : 'Subscribe / Pay Now ($6/mo)'}
        </button>

        <button
          onClick={() => navigate(`/room/${roomId}`)}
          style={{ background: 'transparent', border: 'none', color: '#a3a3a3', cursor: 'pointer', fontSize: '0.9rem', textDecoration: 'underline' }}
        >
          ← Return to Room
        </button>
      </div>
    </div>
  );
}